const PasswordRequirement = ({ text, passed }) => (
  <div className="flex items-center mb-1">
    {passed ? (
      <i className="text-xs fa-solid fa-check text-primary bg-[#D8EBF8] rounded-full flex items-center justify-center min-h-[18px] min-w-[18px]"></i>
    ) : (
      <i className="text-primary border-2 border-[#D8EBF8] rounded-full flex items-center justify-center min-h-[18px] min-w-[18px]"></i>
    )}
    <p className="ml-3 text-xs text-[#525354] font-poppins">{text}</p>
  </div>
);

const PasswordChecker = ({ password, columns = 1 }) => {
  const requirements = [
    {
      text: "Enter from 8 to 20 characters",
      passed: password?.length >= 8 && password?.length <= 20,
    },
    {
      text: "Use upper and lower case letters",
      passed: /[a-z]/.test(password) && /[A-Z]/.test(password),
    },
    {
      text: "Enter at least one number",
      passed: /[0-9]/.test(password),
    },
    {
      text: "Enter at least one symbol (Such as !@#$%^&)",
      passed: /[!@#$%^&*]/.test(password),
    },
  ];

  return (
    <div className={`mt-2 ${columns === 2 ? "grid sm:grid-cols-2 gap-x-6" : ""}`}>
      {requirements?.map((req, index) => (
        <PasswordRequirement
          key={index}
          text={req?.text}
          passed={req?.passed}
        />
      ))}
    </div>
  );
};

export default PasswordChecker;
